module.exports = __webpack_public_path__ + "static/media/upload-24.894ef807.svg";